<template>
	<VAppBar
		:height="navBarHeight"
		:color="isAtTop ? 'transparent' : 'background'"
		class="exchange-athlete-public-profile__app-bar"
		theme="dark"
	>
		<VContainer>
			<div>
				<VImg
					:src="!mobile ? logoInflcr : logoInflcrHex"
					alt="Influencer Logo"
					:width="!mobile ? 180 : 48"
				/>
			</div>
		</VContainer>
	</VAppBar>
</template>

<script lang="ts" setup>
import { onBeforeUnmount, onMounted, ref } from 'vue';
import logoInflcr from '@/assets/logo__inflcr-white.svg';
import logoInflcrHex from '@/assets/logo__inflcr-hex.svg';
import { useDisplay } from 'vuetify/lib/framework.js';

const { mobile } = useDisplay();

const isAtTop = ref(true);

const navBarHeight = !mobile ? 96 : 75;

const onScroll = () => {
	isAtTop.value = window.scrollY < navBarHeight;
};

onMounted(() => {
	window.addEventListener('scroll', onScroll);
});

onBeforeUnmount(() => {
	window.removeEventListener('scroll', onScroll);
});
</script>
